import { useRef, useState } from "react"
import { useAppDispatch, useAppSelector } from "@/shared/lib/redux"
import { closeBulkModal, fetchCreateUserInvitationsBulk, selectCreateUserInvitationOnCreate, selectIsBulkUserInvitationModalOpen } from "../../model"
import notify from "@/shared/lib/notify"
import { Modal } from "@/shared/ui/modal"
import { getErrorMessage } from "@/shared/consts/error-codes"

export const CreateUserInvitationsBulkModal = () => {
    const dispatch = useAppDispatch()
    const isOpen = useAppSelector(selectIsBulkUserInvitationModalOpen)
    const onCreate = useAppSelector(selectCreateUserInvitationOnCreate)

    const [file, setFile] = useState<File | null>(null)
    const [isSubmitting, setIsSubmitting] = useState(false)
    const inputRef = useRef<HTMLInputElement>(null)

    const handleClose = () => {
        setFile(null)
        dispatch(closeBulkModal())
    }

    const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const selected = e.target.files?.[0] ?? null
        setFile(selected)
    }

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault()
        if (!file) return

        setIsSubmitting(true)
        try {
            await dispatch(fetchCreateUserInvitationsBulk(file)).unwrap()
            notify.success('Файл принят, пользователи создаются в фоне')
            onCreate?.()
            handleClose()
        } catch (err) {
            notify.error(getErrorMessage(err))
        } finally {
            setIsSubmitting(false)
        }
    }

    return (
        <Modal isOpen={isOpen} title="Загрузить пользователей из CSV" onRequestClose={handleClose}>
            <form onSubmit={handleSubmit} className="flex flex-col gap-4">
                <div className="flex flex-col gap-1">
                    <p className="text-sm text-gray-500">
                        CSV-файл с колонками: <code>first_name, last_name, phone, email, group_id</code>
                    </p>
                </div>
                <div
                    className="border-2 border-dashed border-gray-300 rounded-lg p-6 flex flex-col items-center gap-2 cursor-pointer"
                    onClick={() => inputRef.current?.click()}
                >
                    <input
                        ref={inputRef}
                        type="file"
                        accept=".csv"
                        className="hidden"
                        onChange={handleFileChange}
                    />
                    {file ? (
                        <span className="text-sm font-medium">{file.name}</span>
                    ) : (
                        <span className="text-sm text-gray-400">Нажмите для выбора .csv файла</span>
                    )}
                </div>
                <div className="w-full flex gap-3">
                    <button type="button" onClick={handleClose} className="form_cancel_button">
                        Отменить
                    </button>
                    <button
                        type="submit"
                        disabled={!file || isSubmitting}
                        className="form_handle_button"
                    >
                        Загрузить
                    </button>
                </div>
            </form>
        </Modal>
    )
}
